import axios from 'axios';

export default axios.create({
    baseURL: 'https://aws.hanacom.co.nz',
    params: {}
}); 